import React from 'react';
import { useT } from '@repo/common';
import HeaderText from '../Common/HeaderText';

const AdminRefundsHeader = () => {
  const t = useT();
  return (
    <div className='flex w-full items-start'>
      <HeaderText label={t('Refunds & Cancellations', '환불 및 취소')} />
    </div>
  );
};

export default AdminRefundsHeader;
